<template>

    <b-select name="ltc_carrier_id" :id=" `${id}ltc_carrier_id` " v-model="carrier">

        <template v-if="withEmpty" slot="first">

            <option value="">{{ emptyText }}</option>
        </template>

        <option v-for=" ( carrier, key ) in carriers " :key=" 'block' + key + carrier.id " :value=" carrier.id ">{{ carrier.initials }}</option>
    </b-select>
</template>

<script>

    import UsesRole from '../mixins/UsesRole';

    export default {

        name: 'CarrierDropdown',

        mixins: [ UsesRole ],

        props: {

            emptyText: {

                type    : String,
                default : '-- All Blocks --',
            },
            withEmpty: {

                type    : Boolean,
                default : true,
            },
            value: {

                type : [ Number, String ],
                default() {

                    return '';
                },
            },
            showInactive: {

                type     : Boolean,
                required : false,
                default  : false,
            },
        },

        data() {

            return {

                id       : Math.ceil( Math.random() * 50 ),
                carriers : [],
                carrier  : '',
                loading  : false,
            }
        },

        methods: {

            async fetchCarriers() {

                let active = this.showInactive ? '' : '&active=1';
                axios.get( `/${this.controller}/carriers?json=1${active}` )
                    .then( ({ data }) => {

                        this.carriers = data;
                    })
                    .catch(e => {});
            },
        },

        watch: {

            carrier( newValue, oldValue ){

                this.$emit( 'input', newValue );
            },

            value( newValue, oldValue ){

                this.carrier = newValue;
            },
        },

        async mounted() {

            await this.fetchCarriers();
            this.carrier = this.value;
        },
    }
</script>
